import { render, staticRenderFns } from "./PendingContractItem.vue?vue&type=template&id=0ff64a60&scoped=true&lang=pug&"
import script from "./PendingContractItem.vue?vue&type=script&lang=js&"
export * from "./PendingContractItem.vue?vue&type=script&lang=js&"
import style0 from "./PendingContractItem.vue?vue&type=style&index=0&id=0ff64a60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff64a60",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
